import script from "./QuestionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionsSection.vue?vue&type=script&setup=true&lang=js"

import "./QuestionsSection.vue?vue&type=style&index=0&id=0b463230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b463230"]])

export default __exports__